import { getLogger } from '@omnia/ui/src/lib/services/logger/logger.service'
import { getOrderItems, getOrderRelatedItemById, getOrderTotalPrice } from '@vista-digital/occ-domain'
import type { OccI18N } from '@vista-digital/occ-ui'
import { BundleItem, CurzonEcommerceDataLayer } from '@/common/services/models-gtm'
import { gtm } from '../gtm.service'

export class TicketBundlesGtmEvents {
    private static get logger() {
        return getLogger('TicketBundlesGtmEvents').value
    }

    public static async addToCart(i18n: OccI18N) {
        try {
            const items = this.getBundleItems(i18n)
            if (!items.length) return
            await gtm.sendEcommerceDataLayer(new CurzonEcommerceDataLayer('add_to_cart', { items }))
        } catch (e) {
            this.logger.error('Error sending add to cart event', e)
        }
    }

    public static async beginCheckout(i18n: OccI18N) {
        try {
            const items = this.getBundleItems(i18n)
            if (!items.length) return
            await gtm.sendEcommerceDataLayer(new CurzonEcommerceDataLayer('begin_checkout', { items }))
        } catch (e) {
            this.logger.error('Error sending begin checkout event', e)
        }
    }

    public static async sendPurchaseEvent(orderId: string, i18n: OccI18N) {
        try {
            const items = this.getBundleItems(i18n)

            if (!items.length) return

            const total = getOrderTotalPrice()?.valueIncludingTax || 0.0
            await gtm.sendEcommerceDataLayer(
                new CurzonEcommerceDataLayer('purchase', {
                    transaction_id: orderId,
                    value: total,
                    currency: 'GBP',
                    items,
                })
            )
        } catch (e) {
            this.logger.error('Error sending purchase event', e)
        }
    }

    private static getBundleItems(i18n: OccI18N) {
        return getOrderItems().map(item => {
            const orderItem = getOrderRelatedItemById(item.itemId)
            const itemName = i18n.translatable(orderItem?.name ?? '')
            const price = item.price.valueIncludingTax
            return new BundleItem({ item_name: itemName, price, item_category: 'Bundles', quantity: 1 })
        })
    }
}
